<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">我的邀请</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="menu-block" v-if="arr.length > 0">
        <div class="ub ub-pc menu-item">
          <span class="width6">头像</span>
          <span class="width6">昵称</span>
          <span class="width6">性别</span>
          <span class="width6">时间</span>
          <span class="ub ub-f1">是否注册</span>
        </div>
  
        <li v-for="(item,index) in  arr" :key="index" >
          <div class="menu-line"></div>
          <div class="ub ub-pc ub-ac menu-item">
              <div class="width6"><img class="photo" v-if="item.photo" :src="item.photo" alt="" /></div>
              <span class="nick">{{ item.nick.length > 4 ? item.nick.substr(0,4) + '...' : item.nick }}</span>
              <span class="width6">{{item.sex}}</span>
              <div class="width6">
                <span v-if="item.dtm_hour < 1">刚刚</span>
                <span v-if="item.dtm_hour >= 1 && item.dtm_hour < 24">{{ Math.floor(item.dtm_hour) }}小时</span>
                <span v-if="item.dtm_hour >= 24">{{ Math.floor(item.dtm_hour / 24) }}天</span>
              </div>
              <div class="width6">
                <span v-if="item.reg_complete == 1">已完成</span>
                <span v-if="item.reg_complete == 0">未完成</span>
              </div>
          </div>
          <div v-if="index < arr.length-1" class="menu-line"></div>
        </li>

      </div>
      <div class="ub ub-pc ub-ac" v-if="arr.length > 0">
          <div class="ub ub-ac ub-pc btn" @click="more()"><span>加载更多</span></div>
      </div>

      <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="arr.length <= 0">
        <img src="../../assets/img/new2024/no-friends.png" alt="">
        <span class="tip-404">你还没有邀请呢，快去邀请拿收益吧</span>
        <div class="btn-404" @click="back()"><span>去邀请</span></div>
      </div>
  
    </div>
  
  
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  export default {
    data() {
      return {
        arr:[],
        last_dtm: "",
        size: 10,
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },

      init_page() {
        this.more();
      },

      more() {
        //好友数为0不请求接口
        var invite_sum = this.$store.state.http_cache.invite_sum;
        if (invite_sum.data_serve.fried_count <= 0) {
            return false;
        }

        this.loading("加载中...",5000);
        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url: "/App/GetInviteList_Friends?uid=" + uid + "&size="+self.size+"&time=" + self.last_dtm,
          success: function(data) {
            self.$loading.close();
            if (data.length <= 0 && self.arr.length > 0) {
              self.$toast.center("没有更多数据");
            }
            for (var i = 0; i < data.length; i++) {
              var user = data[i];
              //初始化数据
              user.photo = self.$store.state.url + "/photo/" + user.photo;
              self.last_dtm = user.create_time;
              user.dtm = user.create_time.replace(/-/g, "/");
              user.create_time = new Date(user.create_time);
              var second = tool.dateDiff_Now(user.create_time);
              user.dtm_hour = Math.floor(second / 3600);
              
            }
            self.arr = self.arr.concat(data);
          },
          error: function(res) {}
        });
      },
      loading(title,time) {
        var self = this;
          this.$loading(title);
          setTimeout(() => {
              self.$loading.close();
          }, time);
      },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background: linear-gradient(to bottom, #FE9CC0, #fff);
    background-size: 100% 100%;
  }
  .menu-block {
    margin: 0.2rem 0.8rem;
    background-color: #fff;
    border-radius: 0.5rem;
    .menu-item {
      height: 3rem;
      justify-content: space-between;
        .width6 {
            text-align: center;
            width: 4.5rem;
            font-size: .9rem;
        }
        .photo {
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
        }
       .nick {
        width: 4.5rem;
        font-size: .9rem;
       }
    }
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }

  .btn {
      margin-top: 0.5rem;
      span {
        font-size: 0.75rem;
        color: #333;
      }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      color: #666;
      margin-top: 1rem;
      font-size: 0.75rem;
    }
    .btn-404 {
      margin-top: 1rem;
      padding: 0.5rem 1rem;
      border-radius: 1rem;
      background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
      span {
        font-size: 0.9rem;
        color: #FFFFFF;
      }
    }
  }
  
  .container-dark {
    min-height: 100vh;
    background: linear-gradient(to bottom, #3c296e, #5f3b48);;
    .menu-block {
      background-color: #2c2b30;
      .menu-item {
        span {
          color: #FDFDFD;
        }
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
    .btn {
      span {
        color: #fff;
      }
    }
  }
  </style>